import {
  AIRPORT_KEY,
  CAR_KEY,
  CITY_KEY,
  FLIGHT_KEY,
  HOTEL_KEY,
  NEIGHBORHOOD_KEY,
  POI_KEY,
  REGION_KEY,
  TRAIN_STATION_KEY,
} from '../constants/categoryConstants';

import { getDisplayName, getFlightsDisplayName } from './suggestionDisplayNameUtils';

const LXP_DISPLAY_NAME_BY_SEARCH_TYPE_FUNC = {
  FLIGHT: getFlightsDisplayName,
  HOTEL: getDisplayName,
  PACKAGE: getDisplayName,
  CAR: getDisplayName,
};

const removeUnderscoresFromType = (resultType, locationType) => (
  locationType ? locationType.replace(/_/g, '') : resultType
);

const mapDataByType = (smartFillData, resultType, lob) => {
  if (!smartFillData) {
    return [];
  }
  return smartFillData.map((result) => ({
    id: result?.id,
    name: LXP_DISPLAY_NAME_BY_SEARCH_TYPE_FUNC[lob](result, resultType),
    label: result?.name,
    airportCode: result?.code || result?.airportCode || result?.iataCode || '',
    parentId: result?.parentId || 0,
    type: removeUnderscoresFromType(resultType, result?.locationType),
    geoLocation: result?.geoLocation || {},
    searchIdType: result?.searchIdType,
  }));
};

export const formatSmartFillFlightData = (smartFillData) => {
  const formattedAirports = mapDataByType(smartFillData?.airports, AIRPORT_KEY, FLIGHT_KEY);
  const formattedCities = mapDataByType(smartFillData?.cities, CITY_KEY, FLIGHT_KEY);
  return [...formattedAirports, ...formattedCities];
};

export const formatSmartFillHotelData = (smartFillData) => {
  const formattedHotels = mapDataByType(smartFillData?.hotels, HOTEL_KEY, HOTEL_KEY);
  const formattedAirports = mapDataByType(smartFillData?.airports, AIRPORT_KEY, HOTEL_KEY);
  const formattedCities = mapDataByType(smartFillData?.cities, CITY_KEY, HOTEL_KEY);
  const formattedNeighborhoods = mapDataByType(
    smartFillData?.neighborhoods, NEIGHBORHOOD_KEY, HOTEL_KEY
  );
  const formattedRegions = mapDataByType(smartFillData?.regions, REGION_KEY, HOTEL_KEY);
  const formattedPointsOfInterest = mapDataByType(
    smartFillData?.pointsOfInterest, POI_KEY, HOTEL_KEY
  );
  const formattedTrainStations = mapDataByType(
    smartFillData?.trainStations, TRAIN_STATION_KEY, HOTEL_KEY
  );
  return [
    ...formattedHotels,
    ...formattedAirports,
    ...formattedCities,
    ...formattedNeighborhoods,
    ...formattedRegions,
    ...formattedPointsOfInterest,
    ...formattedTrainStations,
  ];
};

export const formatSmartFillCarData = (smartFillData) => {
  const formattedAirports = mapDataByType(smartFillData?.airports, AIRPORT_KEY, CAR_KEY);
  const formattedCities = mapDataByType(smartFillData?.cities, CITY_KEY, CAR_KEY);
  const formattedTrainStations = mapDataByType(
    smartFillData?.trainStations, TRAIN_STATION_KEY, CAR_KEY
  );
  const formattedNeighborhoods = mapDataByType(
    smartFillData?.neighborhoods, NEIGHBORHOOD_KEY, CAR_KEY
  );
  const formattedPointsOfInterest = mapDataByType(
    smartFillData?.pointsOfInterest, POI_KEY, CAR_KEY
  );
  const formattedCarRentalLocations = mapDataByType(
    smartFillData?.carRentalLocations, CAR_KEY, CAR_KEY
  );

  return [
    ...formattedAirports,
    ...formattedCities,
    ...formattedTrainStations,
    ...formattedNeighborhoods,
    ...formattedPointsOfInterest,
    ...formattedCarRentalLocations,
  ];
};
